import UserDocument from './UserDocument';

export default UserDocument;
